import React from "react";

import AvatarTable from "../atoms/AvatarTable";
import PersonInformationTable from "../atoms/PersonInformationTable";
import { classNames } from "@/shared/utils/classnames";

export type ColumnPersonInformationAvatarProps = {
  image: string | undefined;
  name: string;
  email?: string;
  fallbackSrc?: string;
  classNameImg?: string;
  classNameName?: string;
  id: number;
  open_user?: boolean;
};

const ColumnPersonInformationAvatar: React.FC<
  ColumnPersonInformationAvatarProps
> = ({
  image,
  name,
  email,
  fallbackSrc,
  classNameImg,
  id,
  open_user,
  classNameName,
}) => {
  return (
    <td
      className={classNames(
        "whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0",
        classNameName
      )}
    >
      <div className="flex items-center">
        <AvatarTable
          image={image}
          fallbackSrc={fallbackSrc}
          className={classNameImg}
        />

        <PersonInformationTable
          name={name}
          email={email}
          id={id}
          open_user={open_user}
        />
      </div>
    </td>
  );
};

export default ColumnPersonInformationAvatar;
